import { Box } from "@mui/material";
import { useEffect, useState } from "react";
import graphQluserRole from "./api/fetch";
import UserRoleListCard from "./components/UserRoleList/UserRoleListCard";

export const UserRole = () => {
  const [loading, setLoading] = useState(false);
  const [userRoleList, setUserRoleList] = useState([]);
  useEffect(() => {
    getRoleList();
  }, []);
  const getRoleList = async () => {
    try {
      setLoading(true);
      const res = await graphQluserRole.getRoleList();
      if (res?.data?.authoring_roleList) {
        setUserRoleList(res?.data?.authoring_roleList);
      }
    } catch (err: any) {
      console.error("Error fetching roles:", err);
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box>
      <UserRoleListCard userRoleList={userRoleList} loading={loading} />
    </Box>
  );
};

export default UserRole;
